import React from "react";
import { useState } from "react";

const YouTube = (props) => {
  const [url, setUrl] = useState("");
  const [description, setDescription] = useState("");
  const handleUrlChange = (e) => {
    setUrl(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const addSugg = async () => {
    if (url.length !== 11) {
      props.addError("Invalid ID");
    } else {
      const res = await props.addToYoutube({ url, description });

      if (res.length === 20) {
        props.addError("Added successfully");
      } else {
        props.addError(res);
      }
    }
  };
  return (
    <div className='title row'>
      <h2 className='m-2 text-center upperfont col-12'>
        Suggest Best YouTube Course
      </h2>
      <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
        <label htmlFor='exampleName'>Your Description of the video</label>
        <input
          type='description'
          className='form-control simplefont text-center'
          id='description'
          name='description'
          value={description}
          placeholder='description'
          onChange={handleDescriptionChange}
        />
      </div>
      <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
        <label htmlFor='exampleCourse'>
          Video ID (Copy from the address bar)
        </label>
        <input
          type='url'
          className='form-control simplefont text-center'
          id='url'
          name='url'
          value={url}
          placeholder='url'
          onChange={handleUrlChange}
        />
      </div>
      <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
        <a href='#' className='nourllook' onClick={addSugg}>
          <button className='slantfont btn btn-block size11 btn-outline-success mx-auto my-4'>
            Suggest
          </button>
        </a>
      </div>
    </div>
  );
};

export default YouTube;
